import "./Animation.css"

export const BackgroundAnimation = () => {
    return (
        <>
            <div>
                <ul className="boxHeight1 boxArea">
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                </ul>
            </div>
        </>
    );
};